import { render, staticRenderFns } from "./RoyRect.vue?vue&type=template&id=1971a37a&"
import script from "./RoyRect.vue?vue&type=script&lang=js&"
export * from "./RoyRect.vue?vue&type=script&lang=js&"
import style0 from "./RoyRect.vue?vue&type=style&index=0&id=1971a37a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports